import { Link } from 'react-router-dom';

interface ComicCardProps {
  slug: string;
  title: string;
  author: string;
  cover: string;
  category: string;
  categoryName: string;
  status: string;
  rating: number;
  views: number;
}

function formatViews(n: number): string {
  if (n >= 10000) return (n / 10000).toFixed(1) + '万';
  return n.toString();
}

export default function ComicCard({
  slug,
  title,
  author,
  cover,
  category,
  categoryName,
  status,
  rating,
  views,
}: ComicCardProps) {
  return (
    <Link to={`/comic/${slug}`} className="group block" data-product-shop="">
      <div className="relative overflow-hidden rounded-lg bg-background-100">
        <div className="aspect-[5/7] overflow-hidden">
          <img
            src={cover}
            alt={title + ' - 蜜桃少年漫画免费阅读'}
            title={title + ' - 漫画全集免费阅读下拉式'}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
          />
        </div>
        {status === '连载中' && (
          <span className="absolute top-2 left-2 bg-primary-500 text-white text-xs px-2 py-0.5 rounded-md whitespace-nowrap">
            连载中
          </span>
        )}
        {status === '已完结' && (
          <span className="absolute top-2 left-2 bg-secondary-500 text-white text-xs px-2 py-0.5 rounded-md whitespace-nowrap">
            已完结
          </span>
        )}
        <span className="absolute top-2 right-2 bg-black/60 text-white text-xs px-1.5 py-0.5 rounded-md whitespace-nowrap">
          {rating}分
        </span>
      </div>
      <div className="mt-2 px-0.5">
        <h3 className="text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
          {title}
        </h3>
        <p className="text-xs text-foreground-500 mt-0.5">{author}</p>
        <div className="flex items-center justify-between mt-1">
          <Link
            to={`/category/${category}`}
            className="text-xs text-accent-600 hover:text-accent-500 transition-colors whitespace-nowrap"
            onClick={(e) => e.stopPropagation()}
          >
            {categoryName}
          </Link>
          <span className="text-xs text-foreground-400">{formatViews(views)} 阅读</span>
        </div>
      </div>
    </Link>
  );
}